export const PRODUCT_SLUGS = {
  FOOD_SENSITIVITY_PKI: 'food-sensitivity',
  FOOD_SENSITIVITY_COMPREHENSIVE: 'food-sensitivity-comprehensive-test',
  WOMENS_HEALTH: 'womens-health-test',
  THYROID: 'thyroid-test',
  COVID: 'covid-19-test',
  COVID_ELLUME: 'covid-ellume-rapid-test',
  COVID_QUIDEL: 'covid-quidel-rapid-test',
  COVID_BD: 'covid-bd-veritor-rapid-test',
  STD_IN_PERSON_TEST_EXPANDED: 'std-in-person-test-expanded',
  STD_IN_PERSON_TEST_BASIC: 'std-in-person-test-basic',
  CHLAMYDIA_GONORRHEA_IN_PERSON_TEST: 'chlamydia-gonorrhea-in-person-test',
  HIV_IN_PERSON_TEST: 'hiv-in-person-test',
  EVERLYWELL_360_FEMALE: '360-full-body-test-female-membership',
  EVERLYWELL_360_MALE: '360-full-body-test-male-membership',
  GALLERI_IN_PERSON_TEST: 'galleri-in-person-test',
};

export const VARIANT_SKUS = {
  COVID: 'covid-19-ew',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

export const COVID_SLUGS = [
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.COVID_ELLUME,
  PRODUCT_SLUGS.COVID_QUIDEL,
  PRODUCT_SLUGS.COVID_BD,
];

export const PHONE_NUMBER_NEEDED_SKUS = [VARIANT_SKUS.COVID];

export const VITAMINS = [
  'multivitamin-gummy',
  'vitamin-b12-500-mcg',
  'vitamin-b6-50-mg',
  'vitamin-d3-2000-iu',
  'omega-3-fish-oil-1000-mg',
];

export const ELIMINATION_DIET_COACHING_SLUG = 'elimination-diet-coaching';

export const NO_INDEX_SLUGS = ['members/consentandnotice'];

export const QUEST_SLUGS = [
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_EXPANDED,
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_BASIC,
  PRODUCT_SLUGS.CHLAMYDIA_GONORRHEA_IN_PERSON_TEST,
  PRODUCT_SLUGS.HIV_IN_PERSON_TEST,
  PRODUCT_SLUGS.EVERLYWELL_360_FEMALE,
  PRODUCT_SLUGS.EVERLYWELL_360_MALE,
  PRODUCT_SLUGS.GALLERI_IN_PERSON_TEST,
];
